<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6">
                        <div class="font-weight-bold body-1">
                            Crear una factura
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" @submit.prevent="save">
                            <billing-form ref="BillingForm" :values="form" @save="save" :serverErrors="serverErrors"></billing-form>
                        </v-form>
                    </v-col>
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button data-cy="cancel-btn" :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button data-cy="accept-btn" :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import BillingForm from "./Form.vue";
export default {
    components: {
        'billing-form': BillingForm,
    },
	data(){
		return {
            loading: false,
            serverErrors: {},
            form: {
                client_id: "",
                project_id: "",
                client_product_id:"",
                warehouse_id: "",
                comments: "",
                initial_date: "",
                ending_date: "",

                sale_orders: [
                    // {
                    //     id: "RE00959",
                    //     check: 0,
                    //     date: "2023-03-31",
                    //     amount: 0,
                    //     services: [
                    //         {service: "serv 1", reference: "p", quantity: "2"},
                    //         {service: "serv 2", reference: "", quantity: "1"},
                    //         {service: "serv 3", reference: "", quantity: "54"},
                    //         {service: "serv 4", reference: "", quantity: "9"},
                    //     ],
                    //     dataTable: {}
                    // },
                    // {
                    //     id: "RE00963",
                    //     check: 0,
                    //     date: "2023-02-10",
                    //     amount: 0,
                    //     services: [
                    //         {service: "serv 1", reference: "", quantity: "21"},
                    //         {service: "serv 8", reference: "", quantity: "9"},
                    //     ],
                    //     dataTable: {}
                    // }
                ],
                    
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Billing",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        
    },
	methods: {

       
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        save(){
            
            //console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.billing.store(form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'Billing'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("errors" in error.response.data)){
                                    if(error.response.data.errors instanceof Object){
                                        Object.keys(error.response.data.errors).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.errors;
                                            error.response.data.errors[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.errors)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario incompleto`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            //set project
            data.client_product_id = data.project_id;
            //set sale orders
            data.sale_orders = [];
            request.sale_orders.forEach(sale => {
                if(sale.check)
                    data.sale_orders.push({sale_order_id: sale.id, amount: sale.amount});
            });

           
            return data;
        }
    },
}
</script>

<style>

</style>